export default __webpack_public_path__ + "static/media/leabhar.f21fcd45.mp3";